import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import SvgColor from 'src/components/svg-color';
import { Link } from 'react-router-dom';

import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: "rgba(225, 225, 225, .01)",
  backgroundImage: 'url("/assets/images/z36/home/sunset22.jpg")',
  backgroundRepeat: "repeat",
  WebkitBackgroundClip: "text",
  textAlign: "left",
  textTransform: "uppercase",
  fontWeight: "900",
  backgroundPositionY :"70px",

  // "-webkit-transform": "scaleY(1.5)",
  // transform: "scaleY(1.5)",
  
  // Define the keyframes animation here
  "@keyframes slideBackground": {
    from: {
      backgroundPositionX: "0%",
    },
    to: {
      backgroundPositionX: "100%",
    },
  },

  // Apply the animation to the component
  animation: "slideBackground 30s linear infinite"
}));

const SERVICES = [
  {
    title: 'Branding',
    description: 'Kreatives Design und Strategie zur Stärkung deiner Marke.',
    icon: '/assets/images/z36/home/icon/branding.png',
    link: '/leistungen/branding',
  },
  {
    title: 'Web Design',
    description: 'Moderne Technologie trifft auf kreatives Design.',
    icon: '/assets/images/z36/home/icon/web-design.png',
    link: '/leistungen/webdesign',
  },
  {
    title: 'Graphic Design',
    description: 'Gestaltung mit modernster Technologie und kreativem Design.',
    icon: '/assets/images/z36/home/icon/grafik-design.png',
    link: '/leistungen/grafikdesign',
  },
  {
    title: 'Website Relaunch',
    description: 'Eine moderne Website, die den aktuellen Designtrends und technischen Standards entspricht.',
    icon: '/assets/images/z36/home/icon/relaunch.png',
    link: '/leistungen/webdesign/website-relaunch',
  },
  {
    title: 'eCommerce',
    description: 'Begleitung auf dem Weg zum erfolgreichen Online-Geschäft mit leistungsstarken eCommerce-Lösungen.',
    icon: '/assets/images/z36/home/icon/ecommerce.png',
    link: '/leistungen/ecommerce',
  },
  {
    title: 'Digitalisierung',
    description: 'Identifizierung geeigneter Anwendungsfälle und Umsetzung von Digitalisierungsprojekten.',
    icon: '/assets/images/z36/home/icon/digitalization.png',
    link: '/beratung/digitalisierung',
  },
];





// ----------------------------------------------------------------------

export default function MarketingServicesInclude() {
  const theme = useTheme();

  return (
    <Box
        sx={{
          p: { xs: 1, md: 2 },
          bgcolor:  theme.palette.grey[900] ,
        }}
      >
    <Container
      component={MotionViewport}
      sx={{
        textAlign: 'left',
        pt: { xs: 5, md: 10 },
        pb: { xs: 10, md: 15 },
        
      }}
    >
    <Grid
        container
        rowSpacing={{ xs: 8, md: 0 }}
        columnSpacing={{ xs: 0, md: 3 }}
      >

<Grid xs={12} md={3}>
    <Box 
/*       sx={{
        ...bgGradient({
          color: alpha(theme.palette.grey[900], 0.5),
          imgUrl: '/assets/images/z36/home/journey.jpg',
        }),
        height: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }} */
    >
        <StyledTypography variant="h2">
      Services
    </StyledTypography>

    </Box>
</Grid>
<Grid xs={0} md={1}></Grid>
      <Grid xs={12} md={8} >
      <Box
        sx={{
          rowGap: { xs: 3, sm: 6 },
          columnGap: 10,
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          },
          
        }}
      >
        {SERVICES.map((value) => (
          <m.div variants={varFade().inUp}>
            <div key={value.title} >
                <Box display="flex" flexDirection={{ xs: 'row', sm: 'column' }} alignItems={{ xs: 'start', sm: 'start' }}>
                    <SvgColor
                        src={value.icon}
                        sx={{
                            width: { xs: 95, sm:55 },
                            height: { xs: 95, sm:55 },
                            
                            mt: { xs: 1, sm: 1.1 },
                            color: 'transparent',
                            background: 'linear-gradient(to bottom right, #60feec, #653bff)',
                        }}
                    />
                    
                    <Box sx={{ ml:{ xs: 2, sm:0 } }} style={{ borderBottom: '1px solid #c1c1c1' }}>
                        <Typography variant="h5" sx={{ mt: { xs: 3, sm: 5 }, mb: 2, color: 'common.white', fontWeight: 500 }}>
                            {value.title}
                        </Typography>
                        <Typography sx={{ color: '#c1c1c1', minHeight: { xs: '60px', sm: '75px', md: '100px'}, mb: 1  }}> 
                            {value.description} 
                        </Typography>
                        <Button 
                          component={Link} 
                          variant="outlined"
                          size="medium"
                          sx={{ 
                            marginBottom: 4, 
                            padding: '5px 18px', 
                            fontWeight: 400, 
                            fontSize: '15px', 
                            textTransform: 'unset',
                            color: 'common.white',
                            borderColor: 'common.white',
                            width: 'fit-content'
                          }}
                          to={value.link}
                        >
                          Mehr Erfahren
                        </Button>
                    </Box>
                </Box>
            </div>

          </m.div>
        ))}
      </Box>
      </Grid>
      </Grid>
    </Container>
    </Box>
  );
}
